module.exports = __webpack_public_path__ + "static/YamadaNoel-94cf5076af0434f26d10f5737b18d98d.jpg";